"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tau = exports.pi = exports.phi = exports.e = void 0;
var pi = exports.pi = Math.PI;
var tau = exports.tau = 2 * Math.PI;
var e = exports.e = Math.E;
var phi = exports.phi = 1.6180339887498948; // eslint-disable-line no-loss-of-precision